<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @removeTab="removeTab(item.name)" :minor='1'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 组织管理页面
 */
import {mapState} from 'vuex'
import OrganiseAdd from '../../../../static/form/OrganiseAdd.vue'
import OrganiseLB from '../assembly/OrganiseLB.vue'
import ComboBox from '../assembly/ComboBox.vue'
import Classification from '../assembly/Classification.vue'
export default {
  components: {
    OrganiseAdd,
    OrganiseLB,
    ComboBox,
    Classification
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '组织列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: OrganiseLB
      }],
      addobj: {
        title: '添加组织',
        name: '2',
        closable: true,
        content: OrganiseAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/Organisegl.vue